// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RatingModal_modal__4fm4H .modal__inner {
  max-width: 560px;
  overflow: auto;
  max-height: 100%;
}
.RatingModal_modal--is-loading__EyOCU .modal__close-btn {
  top: 20px;
  right: 20px;
}
.RatingModal_modal--step-3__X5F1G .modal__close-btn {
  top: 20px;
  right: 20px;
}

.RatingModal_rating-modal-mobile__eNk0a {
  padding: 12px;
  align-items: flex-end;
}
.RatingModal_rating-modal-mobile__eNk0a .modal__header {
  border: none;
  padding-bottom: 0;
  min-height: auto;
}
.RatingModal_rating-modal-mobile__eNk0a .modal__header .modal__title {
  font-size: 22px;
  line-height: 114%;
}

.RatingModal_titleWrap__inuZD {
  margin: 0 8px;
}

.RatingModal_avatar__EZP27 {
  flex-shrink: 0;
}
.RatingModal_avatar__EZP27 svg {
  transform: translateX(-1px);
}

.RatingModal_submitBtn__A\\+CgG {
  width: 100%;
}
@media (min-width: 1200px) {
  .RatingModal_submitBtn__A\\+CgG {
    max-width: 140px;
  }
}

.RatingModal_backBtn__drvP1 {
  max-width: 100px;
}
@media (min-width: 480px) {
  .RatingModal_backBtn__drvP1 {
    max-width: none;
  }
}

.RatingModal_RatingModal__WLJS8 {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
@media (min-width: 1200px) {
  .RatingModal_RatingModal__WLJS8 {
    row-gap: 16px;
  }
}
.RatingModal_RatingModal__title__Kwrw8 {
  color: #000;
  font-size: 22px;
  font-weight: 700;
  line-height: 163%;
}
@media (min-width: 640px) {
  .RatingModal_RatingModal__title__Kwrw8 {
    font-size: 26px;
  }
}
.RatingModal_RatingModal__block__b9cXf {
  display: flex;
  align-items: center;
  grid-column-gap: 6px;
  padding-bottom: 8px;
}
@media (min-width: 1200px) {
  .RatingModal_RatingModal__block__b9cXf {
    padding-bottom: 16px;
  }
}
@media (min-width: 1200px) {
  .RatingModal_RatingModal__block__b9cXf:last-child {
    padding-bottom: 0;
  }
}
.RatingModal_RatingModal__executorTitle__3b1CX {
  font-size: 12px;
  line-height: 144%;
  letter-spacing: -0.24px;
  color: #54575C;
}
@media (min-width: 640px) {
  .RatingModal_RatingModal__executorTitle__3b1CX {
    font-size: 14px;
  }
}
@media (min-width: 1200px) {
  .RatingModal_RatingModal__executorTitle__3b1CX {
    margin-bottom: -8px;
  }
}
.RatingModal_RatingModal__executorName__1BLhL {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  word-break: break-word;
}
@media (min-width: 640px) {
  .RatingModal_RatingModal__executorName__1BLhL {
    font-size: 18px;
  }
}
.RatingModal_RatingModal__ratingBlock__4TIxx {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.RatingModal_RatingModal__ratingBlock__4TIxx label:not(:last-child) {
  margin-left: 11px;
}
.RatingModal_RatingModal__ratingTitle__BuMwK {
  font-size: 16px;
  line-height: 114%;
  font-weight: 500;
}
@media (min-width: 1200px) {
  .RatingModal_RatingModal__ratingTitle__BuMwK {
    font-weight: initial;
  }
}
.RatingModal_RatingModal__input__wYahr.RatingModal_RatingModal__input__wYahr {
  margin-top: 0;
}
.RatingModal_RatingModal__input__wYahr.RatingModal_RatingModal__input__wYahr textarea {
  min-height: 100px !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.RatingModal_RatingModal__input__wYahr.RatingModal_RatingModal__input__wYahr textarea::placeholder {
  color: #bec0c2;
}
.RatingModal_RatingModal__bottom__TnrMw {
  display: flex;
  justify-content: flex-end;
  grid-gap: 12px;
  margin-top: 8px;
}
@media (min-width: 640px) {
  .RatingModal_RatingModal__bottom__TnrMw {
    grid-gap: 8px;
    margin-top: 0;
  }
}
.RatingModal_RatingModal__descrBlock__5TNGw {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
.RatingModal_RatingModal__descr__ZupRh {
  font-size: 14px;
  line-height: 144%;
  letter-spacing: -0.28px;
}
@media (min-width: 640px) {
  .RatingModal_RatingModal__descr__ZupRh {
    font-size: 18px;
  }
}
.RatingModal_RatingModal__descr__ZupRh p {
  display: inline;
  font-weight: 700;
}
.RatingModal_RatingModal__footer__k1jyV {
  display: flex;
  column-gap: 6px;
  justify-content: center;
  align-items: center;
}
.RatingModal_RatingModal__footer__k1jyV p {
  font-size: 11px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.22px;
  opacity: 0.5;
}
.RatingModal_RatingModal__service__DRp8T {
  color: #000;
  font-size: 22px;
  font-weight: 700;
  line-height: 100%; /* 22px */
}
.RatingModal_RatingModal__service__DRp8T span {
  font-weight: 400;
}
.RatingModal_RatingModal__WLJS8 .rating-modal__stars {
  padding: 0 8px;
}
@media (max-width: 1200px) {
  .RatingModal_RatingModal__WLJS8 .rating-modal__stars input {
    position: absolute;
  }
  .RatingModal_RatingModal__WLJS8 .rating-modal__stars svg {
    width: 39px;
    height: 36px;
  }
}

.RatingModal_btnIts__hFCXD {
  height: 44px;
}
@media (min-width: 640px) {
  .RatingModal_btnIts__hFCXD {
    height: 76px;
  }
}
@media (min-width: 1200px) {
  .RatingModal_btnIts__hFCXD {
    height: 44px;
  }
}

.RatingModal_assignees__zCXrt {
  border-bottom: 1px solid #F3F2F2;
}
@media (min-width: 1200px) {
  .RatingModal_assignees__zCXrt {
    border: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/RatingModal/RatingModal.module.scss"],"names":[],"mappings":"AAGM;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAFR;AAUQ;EACE,SAAA;EACA,WAAA;AARV;AAiBQ;EACE,SAAA;EACA,WAAA;AAfV;;AAsBA;EACE,aAAA;EACA,qBAAA;AAnBF;AAqBI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;AAnBN;AAqBM;EACE,eAAA;EACA,iBAAA;AAnBR;;AAyBA;EACE,aAAA;AAtBF;;AAyBA;EACE,cAAA;AAtBF;AAwBE;EACE,2BAAA;AAtBJ;;AA0BA;EACE,WAAA;AAvBF;AAyBE;EAHF;IAII,gBAAA;EAtBF;AACF;;AAyBA;EACE,gBAAA;AAtBF;AAwBE;EAHF;IAII,eAAA;EArBF;AACF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AArBF;AAuBE;EALF;IAMI,aAAA;EApBF;AACF;AAsBE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AApBJ;AAqBI;EALF;IAMI,eAAA;EAlBJ;AACF;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAlBJ;AAoBI;EANF;IAOI,oBAAA;EAjBJ;AACF;AAoBM;EADF;IAEI,iBAAA;EAjBN;AACF;AAqBE;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAnBJ;AAqBI;EANF;IAOI,eAAA;EAlBJ;AACF;AAoBI;EAVF;IAWI,mBAAA;EAjBJ;AACF;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAjBJ;AAmBI;EANF;IAOI,eAAA;EAhBJ;AACF;AAkBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAhBJ;AAkBI;EACE,iBAAA;AAhBN;AAmBE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAjBJ;AAmBI;EALF;IAMI,oBAAA;EAhBJ;AACF;AAmBE;EACE,aAAA;AAjBJ;AAkBI;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAhBN;AAiBM;EACE,cAAA;AAfR;AAoBE;EACE,aAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAlBJ;AAoBI;EANF;IAOI,aAAA;IACA,aAAA;EAjBJ;AACF;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAlBJ;AAoBE;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;AAlBJ;AAmBI;EAJF;IAKI,eAAA;EAhBJ;AACF;AAiBI;EACE,eAAA;EACA,gBAAA;AAfN;AAkBE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAhBJ;AAiBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AAfN;AAkBE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAhBJ;AAiBI;EACE,gBAAA;AAfN;AAoBI;EACE,cAAA;AAlBN;AAoBM;EACE;IACE,kBAAA;EAlBR;EAqBM;IACE,WAAA;IACA,YAAA;EAnBR;AACF;;AAyBA;EACE,YAAA;AAtBF;AAwBE;EAHF;IAII,YAAA;EArBF;AACF;AAuBE;EAPF;IAQI,YAAA;EApBF;AACF;;AAuBA;EACE,gCAAA;AApBF;AAsBE;EAHF;IAII,YAAA;EAnBF;AACF","sourcesContent":[".modal {\n  :global {\n    .modal {\n      &__inner {\n        max-width: 560px;\n        overflow: auto;\n        max-height: 100%;\n      }\n    }\n  }\n\n  &--is-loading {\n    :global {\n      .modal {\n        &__close-btn {\n          top: 20px;\n          right: 20px;\n        }\n      }\n    }\n  }\n\n  &--step-3 {\n    :global {\n      .modal {\n        &__close-btn {\n          top: 20px;\n          right: 20px;\n        }\n      }\n    }\n  }\n}\n\n.rating-modal-mobile {\n  padding: 12px;\n  align-items: flex-end;\n  :global {\n    .modal__header {\n      border: none;\n      padding-bottom: 0;\n      min-height: auto;\n\n      .modal__title {\n        font-size: 22px;\n        line-height: 114%;\n      }\n    }\n  }\n}\n\n.titleWrap {\n  margin: 0 8px;\n}\n\n.avatar {\n  flex-shrink: 0;\n\n  svg {\n    transform: translateX(-1px);\n  }\n}\n\n.submitBtn {\n  width: 100%;\n\n  @media (min-width: 1200px) {\n    max-width: 140px;\n  }\n}\n\n.backBtn {\n  max-width: 100px;\n\n  @media (min-width: 480px) {\n    max-width: none;\n  }\n}\n\n.RatingModal {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n\n  @media (min-width: 1200px) {\n    row-gap: 16px;\n  }\n\n  &__title {\n    color: #000;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 163%;\n    @media (min-width: 640px){\n      font-size: 26px;\n    }\n  }\n  &__block {\n    display: flex;\n    align-items: center;\n    grid-column-gap: 6px;\n    padding-bottom: 8px;\n\n    @media (min-width: 1200px) {\n      padding-bottom: 16px;\n    }\n\n    &:last-child {\n      @media (min-width: 1200px) {\n        padding-bottom: 0;\n      }\n    }\n  }\n\n  &__executorTitle {\n    font-size: 12px;\n    line-height: 144%;\n    letter-spacing: -0.24px;\n    color: #54575C;\n\n    @media (min-width: 640px){\n      font-size: 14px;\n    }\n\n    @media (min-width: 1200px) {\n      margin-bottom: -8px;\n    }\n  }\n  &__executorName {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 114%;\n    word-break: break-word;\n\n    @media (min-width: 640px) {\n      font-size: 18px;\n    }\n  }\n  &__ratingBlock {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n\n    label:not(:last-child){\n      margin-left: 11px;\n    }\n  }\n  &__ratingTitle {\n    font-size: 16px;\n    line-height: 114%;\n    font-weight: 500;\n\n    @media (min-width: 1200px){\n      font-weight: initial;\n    }\n  }\n\n  &__input.RatingModal__input {\n    margin-top: 0;\n    textarea {\n      min-height: 100px !important;\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 24px;\n      &::placeholder {\n        color: #bec0c2;\n      }\n    }\n  }\n\n  &__bottom {\n    display: flex;\n    justify-content: flex-end;\n    grid-gap: 12px;\n    margin-top: 8px;\n\n    @media (min-width: 640px) {\n      grid-gap: 8px;\n      margin-top: 0;\n    }\n  }\n\n  &__descrBlock {\n    display: flex;\n    flex-direction: column;\n    row-gap: 12px;\n  }\n  &__descr {\n    font-size: 14px;\n    line-height: 144%;\n    letter-spacing: -0.28px;\n    @media (min-width: 640px){\n      font-size: 18px;\n    }\n    p {\n      display: inline;\n      font-weight: 700;\n    }\n  }\n  &__footer {\n    display: flex;\n    column-gap: 6px;\n    justify-content: center;\n    align-items: center;\n    p {\n      font-size: 11px;\n      font-weight: 400;\n      line-height: 24px;\n      letter-spacing: -0.22px;\n      opacity: 0.5;\n    }\n  }\n  &__service {\n    color: #000;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 100%; /* 22px */\n    span {\n      font-weight: 400;\n    }\n  }\n\n  :global {\n    .rating-modal__stars {\n      padding: 0 8px;\n\n      @media (max-width: 1200px) {\n        input {\n          position: absolute;\n        }\n\n        svg {\n          width: 39px;\n          height: 36px;\n        }\n      }\n    }\n  }\n}\n\n.btnIts {\n  height: 44px;\n\n  @media (min-width: 640px) {\n    height: 76px;\n  }\n\n  @media (min-width: 1200px) {\n    height: 44px;\n  }\n}\n\n.assignees {\n  border-bottom: 1px solid #F3F2F2;\n\n  @media (min-width: 1200px) {\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `RatingModal_modal__4fm4H`,
	"modal--is-loading": `RatingModal_modal--is-loading__EyOCU`,
	"modal--step-3": `RatingModal_modal--step-3__X5F1G`,
	"rating-modal-mobile": `RatingModal_rating-modal-mobile__eNk0a`,
	"titleWrap": `RatingModal_titleWrap__inuZD`,
	"avatar": `RatingModal_avatar__EZP27`,
	"submitBtn": `RatingModal_submitBtn__A+CgG`,
	"backBtn": `RatingModal_backBtn__drvP1`,
	"RatingModal": `RatingModal_RatingModal__WLJS8`,
	"RatingModal__title": `RatingModal_RatingModal__title__Kwrw8`,
	"RatingModal__block": `RatingModal_RatingModal__block__b9cXf`,
	"RatingModal__executorTitle": `RatingModal_RatingModal__executorTitle__3b1CX`,
	"RatingModal__executorName": `RatingModal_RatingModal__executorName__1BLhL`,
	"RatingModal__ratingBlock": `RatingModal_RatingModal__ratingBlock__4TIxx`,
	"RatingModal__ratingTitle": `RatingModal_RatingModal__ratingTitle__BuMwK`,
	"RatingModal__input": `RatingModal_RatingModal__input__wYahr`,
	"RatingModal__bottom": `RatingModal_RatingModal__bottom__TnrMw`,
	"RatingModal__descrBlock": `RatingModal_RatingModal__descrBlock__5TNGw`,
	"RatingModal__descr": `RatingModal_RatingModal__descr__ZupRh`,
	"RatingModal__footer": `RatingModal_RatingModal__footer__k1jyV`,
	"RatingModal__service": `RatingModal_RatingModal__service__DRp8T`,
	"btnIts": `RatingModal_btnIts__hFCXD`,
	"assignees": `RatingModal_assignees__zCXrt`
};
export default ___CSS_LOADER_EXPORT___;
